import { CookieService } from 'ngx-cookie';
import { Login } from './../models/login';
import { TenantService } from './tenant.service';
import { environment } from './../../environments/environment';
import { Injectable, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { Http, RequestOptions, Headers } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';

import { LocalStorageService } from './local-storage.service';
import { Usuario } from './../models/usuario';

@Injectable()
export class AutenticacaoService {

  private API_URL: string = environment.apiUrl;

  menuEmitter = new EventEmitter<boolean>();

  constructor(
    private localStorage: LocalStorageService,
    private http: Http,
    private router: Router,
    private tenantService: TenantService,
    private cookieService: CookieService
  ) { }

  public autenticar(dadosAutenticacao: any): Observable<Usuario> {
    return this.http.post(this.API_URL + 'Login', dadosAutenticacao)
      .map(
      response => response.json(),
      error => error.json()
      )
  }

  public solicitarNovaSenha(dadosAutenticacao: any): Observable<any> {
    return this.http.post(this.API_URL + 'Login/recuperasenha', dadosAutenticacao)
      .map(
      response => response.json(),
      error => error.json()
      )
  }

  public redefinirSenha(dadosAutenticacao: any, token: String): Observable<any> {    
    let headers = new Headers();
    headers.append('Authorization','Bearer ' + token);
    return this.http.post(this.API_URL + 'login/alterarsenha', dadosAutenticacao,{
      headers : headers
    })    
      .map(
      response => response.json(),
      error => error.json()
      )
  }

  public alterarSenha(login : Login) : Observable<Usuario>{
   return this.http.post(this.API_URL + 'login/alterarsenha', login) 
      .map(
      response => response.json(),
      error => error.json()
      )
  }

  public sair() {
    this.localStorage.remove('tenantAtual');
    this.cookieService.remove('tenantAtual');
    this.localStorage.remove('usuarioAtual');
  }

  public usuarioAtual(): Usuario {
    return this.localStorage.getObject('usuarioAtual') as Usuario;
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/app-services/autenticacao.service.ts